import * as _ from "lodash";
import {Node} from "../Node";
import {AbstractProperty} from "./AbstractProperty";

export class PNumber extends AbstractProperty<number, Node> {

    default: number;
    min: number;
    max: number;
    slider: boolean;

    constructor(args) {
        super({
            type: 'Number',
            default: 0,
            slider: true,
            ...args
        });
    }

    typeCheck(value: number) {
        return _.isNumber(value) && !_.isNaN(value) && _.isFinite(value);
    }

    isEqual(a: number, b: number): boolean {
        return a==b || Math.abs(a-b)<0.00000001;
    }

}
